<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    getLang() {
      var userLang = navigator.language || navigator.userLanguage;

      if(userLang.toLowerCase().includes('ko') || userLang.toLowerCase().includes('kr'))
      {
        userLang = 'ko'
      }

      if(userLang.toLowerCase().includes('en') || userLang.toLowerCase().includes('us'))
      {
        userLang = 'en'
      }
      return userLang;
    },
  }
}
</script>

<style>

</style>
